import { Injectable } from '@angular/core';
import { SidebarItem } from '../sidebar-item';

@Injectable()
export class CreateAccountStep implements SidebarItem {
  id = 'createAcc';
  completed = true;
  link = null;
}
